.page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
}

.card {
  width: 100%;
  max-width: 400px;
  padding: 40px;
  background: var(--ant-color-bg-container);
  border-radius: var(--ant-border-radius-lg);
  box-shadow: var(--ant-box-shadow-secondary);
}

.header {
  margin-bottom: 40px;
  text-align: center;
}

.logo {
  margin-bottom: 16px;
  font-size: 48px;
}

.title {
  margin: 0 0 8px;
  font-size: 28px;
  font-weight: 600;
  color: var(--ant-color-text);
}

.subtitle {
  margin: 0;
  font-size: 16px;
  color: var(--ant-color-text-secondary);
}

.options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.forgot {
  padding: 0;
}

.submit {
  height: 48px;
  font-size: 16px;
  font-weight: 500;
}

.footer {
  margin-top: 40px;
  font-size: 12px;
  color: var(--ant-color-text-tertiary);
  text-align: center;
}
